import React from 'react';

const SkeletonLoader = ({ type = 'card', count = 1 }) => {
  const skeletons = Array.from({ length: count }, (_, i) => i);

  const renderSkeleton = (type) => {
    switch (type) {
      case 'card':
        return (
          <div className="bg-gray-900 rounded-xl p-6 animate-pulse">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-gray-800 rounded-full"></div>
              <div className="ml-4 flex-1">
                <div className="h-4 bg-gray-800 rounded w-3/4 mb-2"></div>
                <div className="h-3 bg-gray-800 rounded w-1/2"></div>
              </div>
            </div>
            <div className="h-4 bg-gray-800 rounded w-full mb-2"></div>
            <div className="h-4 bg-gray-800 rounded w-5/6"></div>
          </div>
        );
      
      case 'list':
        return (
          <div className="space-y-4">
            {skeletons.map((item) => (
              <div key={item} className="bg-gray-900 rounded-lg p-4 animate-pulse">
                <div className="h-4 bg-gray-800 rounded w-3/4 mb-2"></div>
                <div className="h-3 bg-gray-800 rounded w-1/2"></div>
              </div>
            ))}
          </div>
        );
      
      case 'profile':
        return (
          <div className="bg-gray-900 rounded-xl p-6 animate-pulse">
            <div className="flex flex-col items-center mb-6">
              <div className="w-24 h-24 bg-gray-800 rounded-full mb-4"></div>
              <div className="h-6 bg-gray-800 rounded w-1/2 mb-2"></div>
              <div className="h-4 bg-gray-800 rounded w-3/4"></div>
            </div>
            <div className="space-y-3">
              <div className="h-4 bg-gray-800 rounded w-full"></div>
              <div className="h-4 bg-gray-800 rounded w-5/6"></div>
              <div className="h-4 bg-gray-800 rounded w-4/6"></div>
            </div>
          </div>
        );
      
      default:
        return (
          <div className="bg-gray-900 rounded-lg p-4 animate-pulse">
            <div className="h-4 bg-gray-800 rounded w-full"></div>
          </div>
        );
    }
  };

  return (
    <div className="space-y-4">
      {skeletons.map((item) => (
        <div key={item}>
          {renderSkeleton(type)}
        </div>
      ))}
    </div>
  );
};

export default SkeletonLoader;